import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Library as LibraryIcon } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import LibraryManager from "../components/admin/LibraryManager";

export default function Librarian() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user === false) navigate("/login");
    else if (user && user.role !== "librarian" && user.role !== "admin") navigate("/");
  }, [user, navigate]);

  if (!user) return <div className="min-h-screen bg-bone flex items-center justify-center text-muted">Loading…</div>;

  return (
    <div data-testid="librarian-page" className="min-h-screen bg-bone">
      <div className="bg-forest text-bone">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-10 flex items-center justify-between flex-wrap gap-4">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-gold mb-2 flex items-center gap-2"><LibraryIcon size={14} /> Librarian</p>
            <h1 className="font-serif text-4xl md:text-5xl tracking-tight">Library Management</h1>
            <p className="text-bone/50 text-sm mt-2">{user.email}</p>
          </div>
          <button data-testid="librarian-logout-btn" onClick={() => { logout(); navigate("/"); }} className="inline-flex items-center gap-2 border border-bone/25 px-5 py-2.5 rounded-full text-xs uppercase tracking-widest hover:bg-bone hover:text-forest transition-colors">
            <LogOut size={15} /> Logout
          </button>
        </div>
      </div>
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-12">
        <LibraryManager />
      </div>
    </div>
  );
}
